import { Component, OnInit, inject } from '@angular/core';
import { APIService } from "app/services/api.service";
import { LoaderService } from "app/services/loader.service";
import { AppConfig } from "app/app.config";

type fundType = {
  Currency: string;
  Distributions: string;
  FrequencyOfPricingUpdate: string;
  FrequencyOfTrading: string;
  FrequencyOfTradingDesacrition: string;
  FundCode: string;
  FundName: string;
  Id: string;
  PriceSheetLink: string;
  Redemptions: string;
  SubClass: string;
}

type frequencyBucket = {
  Title: string;
  Frequency: string;
  Funds:fundType[];
}

@Component({
    selector: 'nwm-resource-pricing',
    templateUrl: './resource-pricing.component.html'
})
export class ResourcePricingComponent implements OnInit {
  private api = inject(APIService);
  private loaderService = inject(LoaderService);
  private config = inject(AppConfig);

  public buckets: frequencyBucket[] = [
    {Title: 'Daily', Frequency: 'Daily', Funds:[]},
    {Title: 'Weekly', Frequency: 'Weekly', Funds:[]},
    {Title: 'Monthly', Frequency: 'Monthly', Funds:[]},
    {Title: 'Quarterly', Frequency: 'Quarterly', Funds:[]},
    {Title: 'Closed-end Funds<sup>5</sup>', Frequency: 'Closed', Funds:[]}
  ];

  ngOnInit(): void {
    this.loaderService.display(true, this.constructor.name);
    this.api.get<fundType[]>(this.config.resources.priceUrl).subscribe(data => {
        data.forEach(d=>{
          const b = this.buckets.find(f=>f.Frequency === d.FrequencyOfTrading);
          if (b) {
            b.Funds.push(d);
          }
        });
        this.buckets.forEach(b=> {
          b.Funds = b.Funds.sort((a, b) => a.FundName > b.FundName ? 1 : -1);
        });
        this.loaderService.display(false, this.constructor.name);
      },
      () => this.loaderService.display(false, this.constructor.name)
    )
  }
}